import { FormPin } from 'BreetComponents';
import type { formPinModeType } from 'BreetHelpers';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

import PinAccessGuard from './PinAccessGuard';
import { breadCrumbHeaderObject } from './PinManagement.helpers';
import PinManagementFormWrapper from './PinManagementFormWrapper';
import PinStepGuard from './PinStepGuard';

const PinManagement = ({ mode, onSuccess, isModal }: { mode: formPinModeType; onSuccess?: () => void; isModal?: boolean }) => {
	const navigate = useNavigate();

	const [otp, setOtp] = useState<string>('');

	const onLocalSuccess = useCallback(() => {
		navigate('/settings/security')?.catch(console.error);
	}, [navigate]);

	return (
		<PinManagementFormWrapper
			title={breadCrumbHeaderObject[mode]}
			isModal={isModal}
		>
			<PinAccessGuard skip={mode !== 'reset'}>
				<PinStepGuard
					mode={mode}
					setOTP={setOtp}
				>
					<FormPin
						onSuccess={onSuccess ?? onLocalSuccess}
						mode={mode}
						otp={otp}
					/>
				</PinStepGuard>
			</PinAccessGuard>
		</PinManagementFormWrapper>
	);
};

export default PinManagement;
